import React from "react";
import styled from "@emotion/styled";
import { Color } from "../../utils/color";
import { Link } from "gatsby";

export const CategoryCard = (props) => {
  return (
    <SCard data-tile-type={props.tileType}>
      <img src={props.img} alt="category" />
      <Link to={props.href}>{props.txt}</Link>
    </SCard>
  );
};

const SCard = styled.div`
  background-color: ${Color.gray};
  background-position: center;
  background-size: cover;
  position: relative;
  overflow: hidden;
  @media screen and (min-width: 1025px) {
    &:hover {
      img {
        transform: scale(1.2);
      }
    }
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    object-fit: cover;
    object-position: center;
    transition: all 0.2s;
  }
  a {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    text-decoration: none;
    font-size: 1.3rem;
    font-weight: 700;
    color: ${Color.light};
    z-index: 2;
  }
  &[data-tile-type="category001"] {
    grid-area: category001;
    aspect-ratio: 3/1;
  }
  &[data-tile-type="category002"] {
    grid-area: category002;
  }
  &[data-tile-type="category003"] {
    grid-area: category003;
    aspect-ratio: 3/1;
  }
  &[data-tile-type="category004"] {
    grid-area: category004;
    aspect-ratio: 2/1;
  }
  &[data-tile-type="category005"] {
    grid-area: category005;
    aspect-ratio: 2/1;
  }
  &[data-tile-type="category006"] {
    grid-area: category006;
    aspect-ratio: 2/1;
  }
  /* ------------ */
  /* TB */
  @media screen and (max-width: 1023px) {
    &:active {
      img {
        transform: scale(1.2);
      }
    }
    &[data-tile-type="category001"] {
      aspect-ratio: 2/1;
    }
    &[data-tile-type="category002"] {
    }
    &[data-tile-type="category003"] {
      aspect-ratio: 2/1;
    }
    &[data-tile-type="category004"] {
      aspect-ratio: 2/1;
    }
    &[data-tile-type="category005"] {
      aspect-ratio: 2/1;
    }
    &[data-tile-type="category006"] {
      aspect-ratio: 2/1;
    }
  }
  /* ------------ */
  /* SP */
  @media screen and (max-width: 599px) {
    &[data-tile-type="category001"] {
      aspect-ratio: 2/1;
    }
    &[data-tile-type="category002"] {
    }
    &[data-tile-type="category003"] {
      aspect-ratio: 2/1;
    }
    &[data-tile-type="category004"] {
      aspect-ratio: 2/1;
    }
    &[data-tile-type="category005"] {
      aspect-ratio: 2/1;
    }
    &[data-tile-type="category006"] {
      aspect-ratio: 2/1;
    }
  }
`;
